import React, { Component } from "react";
import { connect } from "react-redux";
import "./content.scss";
import fbInsightsIcon from "../../../assets/svg/facebook-insightBlue.svg";
import { Link } from "react-router-dom";
import { configure_progress, gettingStartedProgress } from "../../../actions/globalAction";
import fbiImg from "../../../assets/fbInsights.png";
import { Dimmer, Loader } from "semantic-ui-react";
import { setActiveModule } from "../../../actions/sideBarActions";
class OwnedPageAnalytics extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {}

    configureProgress = async () => {
        await this.props.configure_progress("owned_page_analytics", this.props.total_fields);

        localStorage.setItem("activeModule", "Page Analytics");
        this.props.setModule("Page Analytics");
    };

    render() {
        return (
            <>
                <div className="gs_content">
                    <div className="left_content">
                        <div className="gs_header">
                            <img src={fbInsightsIcon} color="#268af6" className="icon_content" />
                            <span className="content_title">Owned Page Analytics</span>
                        </div>
                        <div className="text_content">
                            <p>{`Do you need detailed information about your owned pages and accounts.  Head here right away!`}</p>

                            <p>{`Connect your accounts and pages and see data getting fetched from all your accounts in one beautiful place.  You will find Twitter, Facebook and Instagram already there.  We are adding more platforms soon.`}</p>
                        </div>
                        <Link to="/owned-page/facebook">
                            <button className="gs_link" onClick={() => this.configureProgress()}>
                                Explore
                            </button>
                        </Link>
                    </div>
                    <div className="right_content">
                        <div id="gs_loader">
                            <Dimmer inverted active>
                                <Loader size="big skiptranslate">Loading</Loader>
                            </Dimmer>
                        </div>
                        <iframe
                            width="320px"
                            height="200px"
                            src="https://www.youtube.com/embed/O22H8tAewqU"
                            title=""
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                            allowFullScreen
                            onLoad={() => (document.getElementById("gs_loader").style.display = "none")}
                            className="content_video"></iframe>
                        {/* <img className="content-img" src={fbiImg} width="350px" height="200px" /> */}
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        configure_progress: (field, total) => dispatch(configure_progress(field, total)),
        gettingStartedProgress: () => dispatch(gettingStartedProgress()),
        setModule: (data) => dispatch(setActiveModule(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(OwnedPageAnalytics);
